/** @returns {boolean} */
export function isBackgroundJobResponse(data) {
  return Boolean(data?.background && data?.job?.job_id);
}

export function backgroundJobQueuedToast(job) {
  const title = job?.title || "Background task";
  const message = job?.message || "Running in background — you will be notified when done.";
  return { title, message };
}
